module.exports = __webpack_public_path__ + "static/img/GerardWhateley.366fbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GerardWhateley.jpg
// module id = cXFd
// module chunks = 0